import { useState } from "react";
import defaultAvatar from "../../images/avatar.png";
import { Person } from "types";
import UserDetailsPopup from "components/pop-up/UserDetailsPopup";

const AssetOwnerCard = ({
  name,
  age,
  phone,
  email,
  person,
}: {
  name?: string;
  age?: string;
  phone?: string;
  email?: string;
  person?: Person;
}) => {
  const [showDetail, setShowDetail] = useState(false);
  return (
    <>
      {" "}
      <div className="flex items-center p-3 bg-white border rounded-lg  w-[400px] m-2">
        <img
          src={defaultAvatar}
          // src={incident?.registeredBy?.img || defaultAvatar}
          alt="avatar"
          className="w-[30] h-[30] rounded-full mr-3"
        />
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-gray-900">{name}</h3>
          <p className="text-xs text-gray-600">
            {age} + {phone} • {email}
          </p>
        </div>
        <button
          onClick={() => setShowDetail(!showDetail)}
          className="ml-4 text-gray-500 hover:text-gray-700 focus:outline-none 
          p-2 bg-gray-500 rounded-full border-[#d4d4d4] border"
          style={{
            background: "#f5f5f5",
            color: "#6b72806b",
            width: "fit-content",
          }}
        >
          <span className="sr-only">Options</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            aria-hidden="false"
            role="img"
            aria-label="View"
          >
            <path
              d="M12 5.5C7 5.5 3.1 9.2 1.5 12c1.6 2.8 5.5 6.5 10.5 6.5s8.9-3.7 10.5-6.5C20.9 9.2 17 5.5 12 5.5z"
              fill="currentColor"
            />
            <circle cx="12" cy="12" r="3" fill="#fff" />
            <circle cx="12" cy="12" r="1.2" fill="currentColor" />
          </svg>
        </button>
      </div>
      <UserDetailsPopup
        setShowDetail={setShowDetail}
        showDetail={showDetail}
        person={person as Person}
        title="Owner Details"
        decription="Detailed information about the asset owner"
      />
    </>
  );
};
export default AssetOwnerCard;
